/**
 * The Discover tab: the texts others have shared (the public library), and a
 * way to websites popular with the language's learners.
 */
import * as preact from "preact";
import { PublicLibrary } from "views/PublicLibraryView";
import * as languagePage from "./languagePage";
import { shownAgain, type PreactPageProps } from "./PreactPage";

export default class DiscoverPageView extends preact.Component<PreactPageProps> {
  private disposeLanguageWatch?: () => void;

  componentDidMount() {
    this.disposeLanguageWatch = languagePage.follow(this.props.appRouter);
    this.setTitle();
  }

  componentDidUpdate(previousProps: PreactPageProps) {
    // Back from another page (the tab kept as left)
    if (shownAgain(this.props, previousProps)) {
      this.setTitle();
    }
  }

  componentWillUnmount() {
    this.disposeLanguageWatch?.();
  }

  private setTitle() {
    localStorage.setItem("libraryOrDashboardPath", "/library");
    languagePage.setTitle(
      "Public Library",
      (languageName) =>
        `Practice your ${languageName} with stories, articles, songs and videos. Click-to-translate & review vocabulary with flashcards.`
    );
  }

  render() {
    return (
      <div class="library">
        <PublicLibrary
          appRouter={this.props.appRouter}
          reselections={this.props.reselections}
        />
      </div>
    );
  }
}
